export default __webpack_public_path__ + "89aeef367af8cb5a73615c4360e38eda.svg";